import { render, staticRenderFns } from "./EditTypeformThemeForm.vue?vue&type=template&id=4acff9d3&"
import script from "./EditTypeformThemeForm.vue?vue&type=script&lang=ts&"
export * from "./EditTypeformThemeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports